<template>
  <div class="info-box">
    <div
      class="flex gap-x-8 h-12 rounded px-5"
      style="background-color: #f3f9f6"
    >
      <c_cell title="会议应收款">
        <template #default>
          <c_money
            :value="state.meetingCollectedPlanStatistic?.amount"
            :key="state.meetingCollectedPlanStatistic?.amount"
            :prefix="false"
            color="#000"
          />
        </template>
      </c_cell>
      <c_cell title="会议已收款">
        <template #default>
          <c_money
            :value="state.meetingCollectedPlanStatistic?.collected_amount"
            :key="state.meetingCollectedPlanStatistic?.collected_amount"
            :prefix="false"
            color="#080"
          />
        </template>
      </c_cell>
      <c_cell title="已申请开票金额">
        <template #default>
          <c_money
            :value="state.amountStatistic?.invoiceAmount"
            :key="state.amountStatistic?.invoiceAmount"
            color="#ffa500"
            :prefix="false"
          />
        </template>
      </c_cell>
    </div>
    <div class="overflow-y-auto mt-3">
      <div
        class="grid gap-x-5 gap-y-3"
        style="grid-template-columns: minmax(300px, auto) 1fr"
      >
        <c_cell title="开票主体" :value="state.info?.invoice_entity" />
        <li class="gap-x-10 grid" style="grid-template-columns: 1fr auto">
          <c_cell title="开票种类">
            <c_status
              arrName="Invoice_Type"
              :value="state.info?.invoice_type"
              :key="state.info?.invoice_type"
            />
          </c_cell>
          <c_cell title="开票金额" class="mr-5">
            <template #default>
              <c_money
                :value="state.info?.amount"
                :key="state.info?.amount"
                bold
                :prefix="false"
                :size="16"
              />
            </template>
          </c_cell>
        </li>
        <c_cell title="会议名称">
          {{ state.info?.meeting?.name }}
          <text class="text-gray-400">{{
            "[" + state.info?.meeting?.number + "]"
          }}</text>
        </c_cell>
        <c_cell title="会议时间">
          {{
            state.info?.meeting?.start_date +
            " ~ " +
            state.info?.meeting?.end_date
          }}
        </c_cell>
        <c_cell title="发票抬头" :value="state.info?.invoice_title" />
        <c_cell title="纳税人识别号" :value="state.info?.tax_no" />
        <c_cell title="电话号码" :value="state.info?.phone || '-'" />
        <c_cell title="单位地址" :value="state.info?.address || '-'" />
        <c_cell title="开户银行" :value="state.info?.opening_bank || '-'" />
        <c_cell title="银行账户" :value="state.info?.bank_account || '-'" />
        <c_cell title="备注" :value="state.info?.remark || '-'" />
      </div>
      <template v-if="state.info?.status == 0 && !props.search">
        <div
          class="border-t border-green-800 border-dashed mt-2 text-center flex justify-center"
        >
          <li
            class="text-green-800 font-bold bg-white px-5"
            style="margin-top: -10px; width: fit-content"
          >
            审批
          </li>
        </div>
        <el-input
          v-model="state.remark"
          type="textarea"
          :autosize="{ minRows: 3 }"
          placeholder="说明"
          class="round"
        />
        <div class="flex items-center justify-center mt-2">
          <el-button type="danger" @click="onSubmit(2)" size="large"
            >不通过</el-button
          >
          <el-button
            type="primary"
            @click="onSubmit(1)"
            size="large"
            class="!w-32"
            >通过</el-button
          >
        </div>
      </template>
      <ul class="font-bold text-sm flex items-center gap-x-1 mt-3 mb-3">
        <li
          style="
            width: 3px;
            background-color: var(--el-color-primary);
            height: 12px;
            border-radius: 10px;
          "
        >
          &nbsp;
        </li>
        操作记录
      </ul>
      <el-timeline class="!text-xs" style="padding-left: 5px">
        <el-timeline-item
          v-for="item in state.meetingInvoiceLogList"
          :key="item"
          type="primary"
          hide-timestamp
        >
          <div class="flex gap-x-3">
            <text>{{ item.create_time }}</text>
            <text>{{ item.add_admin_name }}</text>
            <text class="text-gray-400" style="margin-left: -12px">
              {{ "/" + item.add_department_name }}
            </text>
            <text class="text-primary">{{ item.title }}</text>
          </div>
          <c_cell
            title="操作说明"
            v-if="item.remark"
            :value="item.remark"
            :size="12"
            class="mt-1"
          />
          <el-card class="mt-2" shadow="always" v-if="item.status == 2">
            <ul class="flex gap-x-3">
              <c_cell title="发票号" :value="state.info?.invoice_no" />
              <c_cell title="开票日期" :value="state.info?.invoice_date" />
              <c_cell title="开票备注" :value="state.info?.invoice_remark" />
            </ul>
            <c_cell
              title="附件"
              class="mt-1"
              v-if="state.info?.invoice_attachment?.length > 0"
            >
              <c_UploadFile
                :key="state.info?.invoice_attachment"
                :value="state.info?.invoice_attachment"
                :showAdd="false"
                :showText="true"
              />
            </c_cell>
          </el-card>
          <el-card class="mt-2" shadow="always" v-else-if="item.status == 3">
            <ul class="flex gap-x-3">
              <c_cell title="到款流水" :value="state.info?.receipt_sn" />
              <c_cell title="到款日期" :value="state.info?.receipt_date" />
              <c_cell title="到款备注" :value="state.info?.receipt_remark" />
            </ul>
            <c_cell
              title="附件"
              class="mt-1"
              v-if="state.info?.receipt_attachment?.length > 0"
            >
              <c_UploadFile
                :key="state.info?.receipt_attachment"
                :value="state.info?.receipt_attachment"
                :showAdd="false"
                :showText="true"
              />
            </c_cell>
          </el-card>
          <el-card class="mt-2" shadow="always" v-else-if="item.status == 4">
            <ul class="flex gap-x-3">
              <c_cell
                title="红冲发票号"
                :value="state.info?.reverse_invoice_no"
              />
              <c_cell
                title="红冲日期"
                :value="state.info?.reverse_invoice_date"
              />
              <c_cell
                title="红冲备注"
                :value="state.info?.reverse_invoice_remark"
              />
            </ul>
            <c_cell
              title="附件"
              class="mt-1"
              v-if="state.info?.reverse_invoice_attachment?.length > 0"
            >
              <c_UploadFile
                :key="state.info?.reverse_invoice_attachment"
                :value="state.info?.reverse_invoice_attachment"
                :showAdd="false"
                :showText="true"
              />
            </c_cell>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meetinginvoice_search,
  meetinginvoice_approve,
} from "@/http/fapiaoshenpi";
import { ElMessage, ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
      list_data: [],
    });
    onMounted(() => {
      if (props.id) {
        meetinginvoice_search(props.id).then((res) => {
          if (res.status == 200) {
            const {
              amountStatistic,
              info,
              meetingCollectedPlanStatistic,
              meetingInvoiceLogList,
            } = res.data?.data || {};
            state.amountStatistic = amountStatistic;
            state.info = info;
            state.meetingCollectedPlanStatistic = meetingCollectedPlanStatistic;
            state.meetingInvoiceLogList = meetingInvoiceLogList;
          }
        });
      }
    });
    const onSubmit = (pass) => {
      if (pass == 2 && !state.remark) {
        ElMessage.warning("请输入审批说明！");
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color: ${pass == 1 ? "#080" : "#f00"};">${
          pass == 1 ? "同意" : "拒绝"
        }</strong>该开票申请吗？`,
        "发票审批",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meetinginvoice_approve({
          id: [props.id],
          check_status: pass,
          check_msg: state.remark,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };
    return { state, props, onSubmit };
  },
};
</script>
<style type="scss"></style>
